<template>
  <div class="expericeIntro">
    <div class="content">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
export default {
  name: "ExpericeIntro",
  components: {
    videoPlayer
  },
  data() {
    return {
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "https://escloud.digiwincloud.com/static/zh-CN/video/Promotional-Video.mp4" //url地址
          }
        ],
        // poster:require("../../assets/img/tw-img/poster.png"), //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  }
};
</script>
<style>
.expericeIntro {
    width: 95.5%;
    position: relative;
    top: 26px;
    left: 23px;
}

.content {
  /* width: 900px; */
  /* height: 551px; */
  margin: 0 auto;
  /* margin-top: 20px;
  margin-bottom: 20px; */
}
.content .video-js .vjs-big-play-button{
  top: 45%;
  left: 56%;
  transform: translateX(-50%);
  width: 2em;
  height: 1.2em;
  border: none;
  background: none !important;;
  margin-left: 0px !important;
}
.content .vjs-big-play-button:before{
    content: "";
    position: absolute;
    width: 3em;
    height: 3em;
    background-color: #000;
    border-radius: 50%;
    top: -18px;
    left: -18px;
    z-index: -1;
    transform: scale(0.8);
    opacity: 0.1;
    /* box-shadow: 0px 0px 5px #52c5f3; */
}
.content .video-js .vjs-big-play-button .vjs-icon-placeholder:before{
  top: -1px;
  left: 0px;
  transform: scale(1.5);
  color: #666;
  z-index: 1;
}
.content .video-js .vjs-big-play-button .vjs-icon-placeholder:after{
  content: "";
  position: absolute;
  width: 1.2em;
  height: 0.8em;
  /* background-color: #fff; */
  left: 14px;
  top:20px;
  border-radius: 8px;
}
.content .vjs-poster{
    background-size: 100% 100%;
 }
</style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ExpericeIntro.vue